import { z } from 'zod';

export const sortOptions = [
  'weeklyAvailability',
  'yearsOfExperience',
  'default',
] as const;

export const MyBenchSortFiltersFormSchema = z.object({
  practiceArea: z.string().nullable().default('all'),
  status: z.string().nullable().default('all'),
  search: z.string().nullable().default(''),
  sort: z.enum(sortOptions).nullable().default('default'),
});

export type MyBenchSortFiltersForm = z.infer<
  typeof MyBenchSortFiltersFormSchema
>;
